import { Injectable } from "@angular/core";
import { DayForCalendar, MoodForCalendar } from "../../calendar/calendar.type";
import { Mood } from "@teammood/timeline";


@Injectable()
export class MoodsDistributionBarService {

  constructor() { }

  getMoodsOfAllDays(days: DayForCalendar[]) {
    const moods =  days.map((day) => {
        return day.values;
    });
    return moods.flat();
  }

  countTypeOfMoods(moods: Mood[] | MoodForCalendar[], type: string) {
    const moodsOfTheType = moods.filter((mood) => {
        return mood.mood === type;
    })
    return moodsOfTheType.length;
}
  
  updatePercentage(moods: Mood[] | MoodForCalendar[]) {
    if (moods) {
        const totalMoods = moods.length;

        const percentage = (type: string) => {
            if (totalMoods > 0) {
                return ((this.countTypeOfMoods(moods, type) / totalMoods) * 100);
            } else {
                return 0;
            }
        };


        const excellent = percentage('excellent'),
            good = percentage('good'),
            average = percentage('average'),
            hard = percentage('hard'),
            bad = percentage('bad');

        const toObject = function (value: number) {
            return {
                value: value,
                percentage: value + '%',
                label: Math.round(value) + '%',
            };
        };

        return {
            excellent: {...toObject(excellent), number: this.countTypeOfMoods(moods, 'excellent')},
            good: {...toObject(good), number: this.countTypeOfMoods(moods, 'good')},
            average: {...toObject(average), number: this.countTypeOfMoods(moods, 'average')},
            hard: {...toObject(hard), number: this.countTypeOfMoods(moods, 'hard')},
            bad: {...toObject(bad), number: this.countTypeOfMoods(moods, 'bad')},
        };
    }
};
}